// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","grid":"Header_grid__Ed74q","logo":"Header_logo__UsziS","button":"Header_button__eZN2O"};